export default {"src":"/_next/static/media/handbal.196fdd97.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};